import { IListItem } from '../utils/interfaces';
import MilitaryTechIcon from '@mui/icons-material/MilitaryTech';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import {
  NOTIFICATIONS,
  PROJECTS,
  RESOURCE_ALLOCATIONS,
  PENDING_ACTIONS,
  TOOLS_AND_TECHNOLOGIES,
  USERS
} from '../utils/routes';

const ProjectsIcon: React.FC = () => (
  <img src="/images/ProjectsIcon.svg" alt="Projects Icon" />
);

const NotificationIcon: React.FC = () => (
  <img src="/images/NotificationIcon.svg" alt="Projects Icon" />
);

const UsersIcon: React.FC = () => (
  <img src="/images/UsersIcon.svg" alt="Users Icon" />
);

const ResourceAllocationIcon: React.FC = () => (
  <img
    src="/images/ResourceAllocation/MenuIcon.svg"
    alt="Resource Allocation Icon"
  />
);

export const menuItems: IListItem[] = [
  {
    title: 'Resource Allocation',
    icon: <ResourceAllocationIcon />,
    path: RESOURCE_ALLOCATIONS,
    permissionGroup: 'resource_allocation',
    menuGroup: 'USER MANAGEMENT'
  },
  {
    title: 'Projects',
    icon: <ProjectsIcon />,
    path: PROJECTS,
    permissionGroup: 'project',
    menuGroup: 'USER MANAGEMENT'
  },
  {
    title: 'Notifications',
    icon: <NotificationIcon />,
    path: NOTIFICATIONS,
    permissionGroup: 'notification',
    menuGroup: 'USER MANAGEMENT'
  },
  {
    title: 'Pending Actions',
    icon: <PendingActionsIcon />,
    path: PENDING_ACTIONS,
    permissionGroup: 'pending_action',
    menuGroup: 'USER MANAGEMENT'
  },
  {
    title: 'Tools And Technologies',
    icon: <MilitaryTechIcon />,
    path: TOOLS_AND_TECHNOLOGIES,
    permissionGroup: 'tools',
    menuGroup: 'USER MANAGEMENT'
  },
  {
    title: 'Users',
    icon: <UsersIcon />,
    path: USERS,
    permissionGroup: 'rolesAndDepartments',
    menuGroup: 'USER MANAGEMENT'
  }
];
